export default "__VITE_ASSET__Chc$P8Ms__"